import script from "./SidebarCourse.vue?vue&type=script&setup=true&lang=js"
export * from "./SidebarCourse.vue?vue&type=script&setup=true&lang=js"

import "./SidebarCourse.vue?vue&type=style&index=0&id=5dd07944&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5dd07944"]])

export default __exports__